import { gql } from "graphql-request";

export const GET_ALL_TRADEDATA_REAL = gql`
  query GetAllTradeData(
    $pageNo: Int
    $pageSize: Int
    $sortBy: String
    $sortType: Int
    $clientId: String
    $tenantId: String
    $searchKeyword: String 
  ) {
    getAllTradeData(
      pageNo: $pageNo
      pageSize: $pageSize
      sortBy: $sortBy
      sortType: $sortType
      clientId: $clientId
      tenantId: $tenantId
      searchKeyword: $searchKeyword
    ) {
      data {
        _id
        entrySummaryNumber
        entryLine
        filerCode
        entryTypeCode
        importerNumber
        portOfEntryCode
        entryDate
        entrySummaryDate
        entrySummaryCreateDate
        entrySummaryLineNumber
        reviewTeamNumber
        countryOfOriginCode
        countryOfExportCode
        manufacturerID
        foreignExporterID
        lineSPICode
        standardVisaNumber
        textileCategoryCode
        textileCategory
        tariffOrdinalNumber
        htsNumberFull
        lineTariffQuantity1
        hts8Digit
        lineTariffUOM1Code
        lineTariffQuantity2
        lineTariffUOM2Code
        lineTariffQuantity3
        lineTariffUOM3Code
        lineTariffGoodsValueAmount
        lineTariffDutyAmount
        relatedPartyIndicator
        entryDateSeconds
        ch98
        ch99
        ch98Code
        ch99Code
        ch99Code2
        mtb
        sec201
        sec232
        sec301
        exclusions
        mfnDuty
        mtbDuty
        duty201
        duty232
        duty301
        exclusionSavings
        sec301List
        totalEstimatedMPFAmount
        totalEstimatedHMFAmount
        totalEstimatedOtherFeeAmount
        totalEstimatedFeeAmount
        reconciliationIndicator
        reconciliationIssue
        dutySavings
        rate
        count
        lineMPFAmount
        lineHMFAmount
        uniqueIndicator
        filteredOut
        paidNotPaid
        mpfFactor
        originalFile
        headerFeeFile
        lineFreeFile
        mpfTableFile
        toAdjust
        revisedMPF
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;
export const CREATE_TRADE_DATA = gql`
  mutation CreateTradeData($tradeData: TradeDataInput!) {
    createTradeData(tradeData: $tradeData) {
      data
    }
  }
`;

export const GET_ALL_TRADEDATA_LOGS = gql`
  query GetTasksByTenant($input: TaskQueryInput!) {
    getTasksByTenant(input: $input) {
      progress
      status
      uploadTime
      lastHeartbeat
    }
  }
`;

export const DELETE_TRADE_DATA = gql`
  mutation DeleteAllTradeData($tenantId: String, $clientId: String) {
    deleteAllTradeData(tenantId: $tenantId, clientId: $clientId) {
      data
    }
  }
`;


